<template>
    <Tab  @dimensions_changed="d => landscape = d.orientation === 'landscape' || d.width >= 800">
        <div class="wraper grid">
            <section class="content text-w">
                <h2>Тимчасові споруди</h2>
                <p>
                На карті є інформація про тимчасові споруди для здійснення підприємницької діяльності (кіоски), розміщені на території міста. Ви можете вибрати місце для започаткування чи розширення власного бізнесу або перевірити законність розміщення тимчасової споруди. Якщо на карті не відображена тимчасова конструкція, але за фактом вона є за цією адресою, це може свідчити, що вона встановлена незаконно.
                </p>
            </section>

            <!--section class="informer-stripe full-width grid interactive-bg">
                <div class="content">
                    <h5>Статуси тимчасових споруд:</h5>
                    <top-chart v-if="top_data" :data='top_data'></top-chart>
                </div>
            </section-->

            <section v-if="!landscape" class="full-width grid interactive-bg">
                <rotate-your-phone class="content text-w"/>
            </section>
            
            <template v-else>
             <div class="content" style="margin-top: 1em; margin-bottom: 2em;">
                <info-spoiler>
                    <template v-slot:caption>
                        <img src="../assets/backhand_finger_down.png" style="width: 2em; vertical-align: middle;" /> <h6> Як користуватись картою? </h6>
                    </template>
                    <div class="fucking-text">

<p>Праворуч від карти розміщений фільтр за статусом тимчасової споруди, в дужках вказана кількість споруд із відповідним статусом.</p>
<p>Статус “Розміщення припиняється” означає, що тимчасова споруда має бути демонтована найближчим часом, оскільки порушені умови її розміщення – наприклад, сплив строк дії договору, слід провести реконструкцію тощо.</p>
<p>Статус “Може бути продовжено після усуненні зауважень” означає: якщо власник тимчасової споруди в найкоротші терміни приведе все до ладу, тимчасова споруда може функціонувати й надалі.</p>
<p>Статус “Може бути продовжено” означає, що все добре, і тимчасова споруда може перебувати на своєму місці до наступного перегляду схеми розміщення тимчасових споруд.</p>
<p>Статус “Пропонується для розміщення” вказує на вільні місця, де можна розташувати споруди.</p>
<p>Статус “Перспективне розміщення” повідомляє, що згодом, у тривалій перспективі, тут можна буде звести тимчасові споруди.</p>
<p>Якщо клікнути на точку на карті, можна отримати додаткову інформацію: статус, унікальний код тимчасової споруди на схемі, точну адресу, площу, інформацію про територію, на якій розміщено споруду (назву району та зображення), архітектурний тип тимчасової споруди – відповідно до каталогу малих архітектурних форм – та безпосередній план розміщення споруди на місцевості (зображення можна збільшити, клікнувши на них).</p>

                    </div>
                </info-spoiler>
            </div>

            <section class="full-width map-and-filters">
                <div class="map-container">
                    <div class="map-loading" v-if="!points"> <p>Завантаження ...</p> </div>
                    
                    <points-map v-else
                        :points='map_data'                
                        ref="mapymapref"
                        @point-selected="change_point_selected"
                        :selected_point="selected_point"
                        :points_style="points_style"
                        :address_search_index="address_search_index"
                    />
                </div>
                
                <div class="filters-container">
                    <p>Статус тимчасової споруди:<p>  
                    <div v-if="points && stats" class="category-buttons">
                        <div v-for="(c, index) in categories" :key="index">
                            <checkbox v-model="c.active"/>&nbsp;
                            <div class="check-legend" :style="`background-color: ${c.color}`"></div>
                            &nbsp;<span class="tiny-text" style="display: inline-grid;"> {{c.text}} <span class="">({{ stats.get(c.id) }})</span></span>
                        </div>
                    </div>
                </div>
            </section>

            <section class="full-width grid infobox-container interactive-bg">
                <div class="content">
                    <info-box v-if="selected_point" :d="selected_point" :categories="categories"></info-box>
                    <div v-else>
                        <div class="alert-box">
                            <p style="text-align: center"> <img src="../assets/finger_up.png" style="width: 2em; vertical-align: middle;" /> Клікніть точку на карті щоб побачити інформацію про неї </p>
                        </div>
                    </div>
                </div>
            </section>
            </template>
        </div>

        <div class="full-width grid">
            <section class="content text-w after-text">

<p>Карта містить інформацію про план та адресу розташування, архітектурний тип, площу, поточний статус та інформацію щодо подальшого розміщення. Карта відповідає комплексній схемі розміщення тимчасових споруд для провадження підприємницької діяльності на території міста Слов'янськ, затвердженій рішенням <a target="_blank" href="http://docs.slavrada.gov.ua/dt/13908/">Слов'янської міської ради  від 29.05.2019 №46—LVX—7</a>.</p>
                <div class="alert-box">
<p>Якщо тимчасова споруда занедбана, розміщена на пішохідному маршруті, або ж ви бачите на ній непередбачені архітектурним типом прибудови, та з будь-яких інших питань – звертайтеся до Слов'янської міської ради, зокрема – в Управління містобудування та архітектури (площа Соборна, 2, каб. 60-62, тел. <a href="tel:+3806262-2-51-41">06262 2-51-41</a>, <a href="tel:+38062-2-14-00">06262 2-14-00</a>, <a href="mailto:slavgorarch@i.ua"> slavgorarch@i.ua </a>).</p>
                </div>
            </section>
        </div>
    </Tab>
</template>

<script>
import Tab from './Tab';
import PointsMap from '../components/PointsMap'
import InfoBox from '../components/mafy/InfoBox'
import SelectButton from '../components/mafy/SelectButton'
import KnownHeightBlock from '../components/KnownHeightBlock'
import Checkbox from '../components/other/Checkbox'
import InfoSpoiler from '../components/other/InfoSpoiler'
import TopChart from '../components/TopChart'
import RotateYourPhone from '../components/other/rotate/RotateYourPhone'
import { create_index } from '../utils.js'

import * as d3 from 'd3'
import * as d3_array from 'd3-array'

export default {
    name: "mafy-tab",

    components: {
        Tab,
        PointsMap,
        InfoBox,
        SelectButton,
        KnownHeightBlock,
        Checkbox,
        InfoSpoiler,
        TopChart,
        RotateYourPhone
    },

    data() {
        return {
            points: null,
            selected_point: null,
            stats: null,
            top_data: null,

            categories: {
                1: {
                    text: "Розміщення припиняється",
                    active: true,
                    color: "#B64E97",
                    id: 1
                },
                2: {
                    text: "Може бути продовжено при усуненні зауважень",
                    active: true,
                    color: "#C98BBC",
                    id: 2
                },
                3: {
                    text: "Може бути продовжено",
                    active: true,
                    color: "#4762AB",
                    id: 3
                },
                4: {
                    text: "Пропонується для розміщення",
                    active: true,
                    color: "#86D1F5",
                    id: 4
                },
                5: {
                    text: "Перспективне розміщення",
                    active: true,
                    color: "#009FE3",
                    // stroke: true,
                    // lightbg: true,
                    id: 5
                },
            },
            buffer_height: 0,
            landscape: true,
        }
    },

    mounted() {
        this.loadData()
    },

    computed: {
        map_data() {
            if (!Object.entries(this.categories).some(c => !c.active)) return this.points;

            return this.points.filter(p => this.categories[p.properties.kod_ststext].active)
        },

        address_search_index() {
            return Array.from(this.address_index, ([key, value]) => ({ text: key || "не вказано", term: (key || "не вказано").toLowerCase(), p: value[0] }))
        }
    },

    methods: {
        async loadData() {
            var data = await d3.json('data/mafy.json')
            this.points = data.features;
            
            this.stats = d3_array
                .rollup(this.points, v => v.length, d => d.properties.kod_ststext)

            this.top_data = Array.from(this.stats.entries())
                .map(o => ({key: this.categories[o[0]].text, params: {total: o[1]}}) )
                .sort((o1, o2) => o2.params.total - o1.params.total)
                //.slice(0, top_size)


            this.address_index = create_index(
                this.points,
                d => d.properties.misceroztash,
                // d3.descending,
                // d => d.properties.date
            )

        },

        change_point_selected(point) {
            this.selected_point = point
        },

        points_style(feature) {
            let cat = this.categories[feature.properties.kod_ststext]
            return {
                radius: 3,
                fillColor: cat.color,
                color: "#000",
                weight: 1,
                opacity: 1,
                fillOpacity: 0.65,
                stroke: cat.stroke
            };
        },

    }
}

</script>

<style lang="scss" scoped>

.category-buttons {
    width: 100%;
    display: flex;
    flex-flow: column;
    // justify-content: space-evenly;
    gap: 1em;
    margin-top: 1em;
}

// /deep/ .select-button {
//     //color: white;
//     max-width: 20em;
//     width: 100%;
//     min-height: 5em; 
//     border-radius: 3em;
// }


.map-and-filters{
    display: grid;
    grid-template-columns: 6fr 3fr;

    .filters-container {
        padding: 1rem;
        background-color: #E7EEF3;   
    }

}

.infobox-container {
    padding: 2em 0;
}

.after-text {
    margin: 3em 0;
}


.topchart-section {
    display: flex;
    gap: 2em;
    justify-content: space-between;
}

/deep/ .topbarchart {
    width: 100%;
    max-width: 44em;
    min-width: 20em;
    font-size: 16px;

    .param.param-total {
        background-color: #333;
        z-index: 10;
        color: white;
    }


    // .row:hover {
    //     .param {
    //         background-color: white;
    //         border: 1px solid black;
    //         color: black;
    //     }
    //     //.param.param-completed {background-color: $t1_completed_hot;}

    // }
}

/deep/ .info-spoiler {
    background: white;

    h6 {
        margin-bottom: 0;
    }
}


</style>
